import { RevenueCategory } from "@/interfaces";
import api from "@/lib/axios";

export const revenueCategoryService = {
  async index() {
    const response = await api.get<{ data: RevenueCategory[] }>(
      "/revenue_category",
    );
    return response.data;
  },

  async create(name: string) {
    const response = await api.post("/revenue_category", { name });
    return response.data;
  },

  async update(id: number, name: string) {
    const response = await api.put(`/revenue_category/${id}`, { name });
    return response.data;
  },

  async destroy(id: number) {
    const response = await api.delete(`/revenue_category/${id}`);
    return response.data;
  },
};
